module.exports = __webpack_public_path__ + "static/media/icon-xmark.6ce62faa.svg";